export const burgerAnimations = {
  hidden: { x: 0, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
  },
};
